<template>

    <AjanlatBase :titleExtra="titleExtra"  v-if="false">

        <v-form slot="biztositoi-adatok" ref="ajanlat-adatokk">

            <v-layout row wrap>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';

export default {
    name: 'AjanlatAdatokB39_V0',
    components: {AjanlatBase },
    mixins: [offerData],
    version: 'v0',
    data() {
        return {};
    },
};
</script>
